// Utilities for Chilean RUT handling
export function normalizeRut(value) {
  if (!value) return "";
  let s = String(value).trim().replace(/\./g, "");
  if (s.endsWith("k")) s = s.slice(0, -1) + "K";
  return s;
}

export function formatRut(value) {
  // Turns "13635891-K" into "13.635.891-K" for display
  if (!value) return "";
  const s = normalizeRut(value);
  const hasDash = s.includes("-");
  const body = hasDash ? s.split("-")[0] : s.slice(0, -1);
  const dv = hasDash ? s.split("-")[1] : s.slice(-1);
  if (!body) return s;
  const withDots = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${withDots}-${dv}`;
}

export function formatCLP(value) {
  if (value == null || isNaN(value)) return "$0";
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatNumber(value) {
  if (value == null || isNaN(value)) return "0";
  return new Intl.NumberFormat("es-CL").format(value);
}
